import React, { Component, Fragment } from "react";
import utils from "./utils";

export default class Select extends Component {

    constructor(props) {
        super(props);
        
        this.state = {
            aplicationName: "Select",
        }
        
    }

    render() {
        return (
            <Fragment>
                <div className="row">
                    <div className="col-md-12">
                        <div className="form-group">
                            {this.props.label}
                            <select name="modalidade" onChange={this.props.selectModalidade} className="form-control" required>
                                {this.props.visible ? 
                                    this.props.visible
                                    :
                                    <option value="Todas">Todas</option>
                                }
                                { 
                                    utils.modalidades.map(modalidades => {
                                        return(
                                            <option key={modalidades.cr} value={modalidades.modalidade}>{modalidades.modalidade}</option>
                                        )
                                    })
                                }
                            </select>
                        </div>
                    </div>
                </div>
                {/*<option key={modalidades.cr} value={[modalidades.modalidade, modalidades.cr]}>{modalidades.modalidade}</option>*/}
            </Fragment>
        )
    }

}
